import { render, staticRenderFns } from "./CostsPricesUnit.vue?vue&type=template&id=04c6975f"
import script from "./CostsPricesUnit.vue?vue&type=script&lang=js"
export * from "./CostsPricesUnit.vue?vue&type=script&lang=js"
import style0 from "./CostsPricesUnit.vue?vue&type=style&index=0&id=04c6975f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports